import React, { useMemo, useState } from 'react';

import PdfHeader from '../layout-pdf-plan-input/pdfHeader';
import { generatePDF } from '../../shared/api'
import { SERVER_URL } from '../../config';

import {
    Button,
    Dialog,
    DialogTitle,
    Grid,
} from "@mui/material";

import { firstLetterUpperCase } from '../../shared/first-letter-upper';

import { START_IMAGE } from "./base64/startImage";
import { BLUE_BACKGROUND } from "./base64/blueBackground"
import { TOM_HEGNA } from './base64/tomHegna'
import { ERIK_SUSSMAN } from './base64/erickSusman'
import { PAGE3_RIGTHSIDE } from './base64/page3RigthSide'

import { grey } from '@mui/material/colors';
import {
    currencyFormatNoDecimals,
    formatNumberToPercentage,
    mergeClientCoClientAge,
    removeSpaces
} from '../../shared/shared';
import { useSelector } from 'react-redux';

import { FiaTransfers } from './fiaTransfer';
import { InsuranceTransfers } from './insuranceTransfers';
import { ViolatilityInsuranceTransfers } from "./insuranceTransfers";
import { RothConversion } from './rothConversion';
import { FutureGoals } from './futureGoals';
import { Accounts } from './accounts';
import { Incomes } from './incomes';
import { Goals } from './goals';
import { GraphicPie } from '../graphic-pie';

import { PAGE3_LEFTSIDE } from './base64/page3LeftSide';
import { ACCUMULATION_CHART } from './base64/accumulationChart';
import { DISTRIBUTION_CHART } from './base64/distributionChart';
import { VOLATILITYBUFFER_LEFTSIDE } from './base64/volatilityBufferLeftSide';
import { VOLATILITYBUFFER_RIGTHSIDE } from './base64/volatilityBufferRigthSide';
import { Loader } from '../spin-loader';
import { TableCashFlow } from './tableCashFlow';
import { VideoModalTomHegna } from '../video-modal-tom';
import { useModal } from '../../hooks/useModal';


const RoadmapReport = (props) => {
    const { handleClose, handleOk, open } = props;
    const [state, setState] = useState({
        loading: false,
    })
    let fpName = "";
    const blueColor1 = '#157ee8';
    const greenColor1 = "#47d47f"
    const familyFont = '"Verdana", "Helvetica", "Arial", sans-serif';

    const planInput = useSelector(state => state.dataStore.getIn(['planInput']));
    const spouse = useSelector(state => state.dataStore.getIn(['currentClient', 'spouse']))?.toJS();
    const currentCashInflow = useSelector((state) => state.dataStore.get("currentPlanCashFlow"));
    const futureCashInflow = useSelector((state) => state.dataStore.get("currentFuturePlanCashFlow"));
    const isFutureDestinationLocked = useSelector(state => state.dataStore.get('lockFutureDestination'));
    const { isOpen, openModal, closeModal, message } = useModal();

    const advisorId = useSelector(state => state.dataStore.getIn(['currentClient', 'advisorId']));
    const ifwUsers = useSelector((state) => state.dataStore.getIn(["ifwUsers"])).toJS();
    const fp = ifwUsers.filter(item => item.id === advisorId);
    if (fp.length > 0) {
        fpName = `${fp[0].firstName} ${fp[0].lastName}`;
    }

    const currentPlanInflow = useMemo(() => {
        return currentCashInflow?.toJS();
    }, [currentCashInflow])

    const futurePlanInflow = useMemo(() => {
        return futureCashInflow?.toJS();
    }, [futureCashInflow])

    const fiaReports = futureCashInflow?.toJS()?.fiaReport.filter(item => item.length > 0) || [[]];

    const insuranceReport = futureCashInflow?.toJS().hasOwnProperty('insurance') ?
        futurePlanInflow.insurance === null ? [] : futurePlanInflow.insurance.filter(e => e.length > 0)
        : [];

    // CHECK HERE.
    const cashInflow = futureCashInflow?.toJS().hasOwnProperty('cashInflow') ?
        futurePlanInflow?.cashInflow === null ? currentPlanInflow.cashInflow : futurePlanInflow?.cashInflow
        : currentPlanInflow.cashInflow;

    const cashOutflow = futureCashInflow?.toJS().hasOwnProperty('cashOutflow') ?
        futurePlanInflow?.cashOutflow === null ? currentPlanInflow.cashOutflow : futurePlanInflow?.cashOutflow
        : currentPlanInflow.cashOutflow;

    const accountsSummary = futureCashInflow?.toJS().hasOwnProperty('accountsSummary') ?
        futurePlanInflow?.accountsSummary === null ? currentPlanInflow.accountsSummary : futurePlanInflow?.accountsSummary
        : currentPlanInflow.accountsSummary;

    const cashFlowSummary = futureCashInflow?.toJS().hasOwnProperty('cashFlowSummary') ?
        futurePlanInflow?.cashFlowSummary === null ? currentPlanInflow.cashFlowSummary : futurePlanInflow?.cashFlowSummary
        : currentPlanInflow.cashFlowSummary;

    const taxReportData = currentPlanInflow?.cashOutflow.map(item => {
        const futureData = futurePlanInflow?.cashOutflow.find(d => d.year === item.year);

        const currentTotalTax = item.incomeTax + item.capitalGainsTax;
        const futureTotalTax = futureData ? (futureData.incomeTax + futureData.capitalGainsTax ) : 0;

        const totalTaxDifference = futureTotalTax - currentTotalTax;
        const socialDifference = futureData ? (futureData.socialSecurityTax - item.socialSecurityTax) : (-item.socialSecurityTax);

        return {
            year: item.year,
            age: item.clientAge,
            currentTotalTaxes: currentTotalTax,
            futureTotalTaxes: futureTotalTax,
            currentSocialSecurity: item.socialSecurityTax,
            futureSocialSecurity: futureData ? futureData.socialSecurityTax : 0,
            diffTotalTaxes: totalTaxDifference,
            diffSocialSecurity: socialDifference
        }
    });

    const downloadReport = () => {

        setState((v) => ({ ...v, loading: true }))
        const rrpGetStarted = document.getElementById('rrp-GetStarted').outerHTML
        const rrpWelcome = document.getElementById('rrp-Welcome').outerHTML
        const rrpIncomeTaxDebtCharts = document.getElementById('rrp-income-tax-debt-charts').outerHTML
        const rrpAccumulationChart = document.getElementById('rrp-accumulation-chart').outerHTML
        const rrpDistributionChart = document.getElementById('rrp-distribution-chart').outerHTML
        const rrpVolatilityBufferChart = document.getElementById('rrp-volatility-buffer-chart').outerHTML
        const rrpClientSpouseTaxSettings = document.getElementById('rrp-client-spouse-tax-settings').outerHTML
        const rrpPlanInputAccounts = document.getElementById('rrp-plan-input-accounts').outerHTML
        const rrpPlanInputIncomes = document.getElementById('rrp-plan-input-incomes').outerHTML
        const rrpPlanInputGoals = document.getElementById('rrp-plan-input-goals').outerHTML
        const rrpCurrentDestination = document.getElementById('rrp-current-destination').outerHTML
        const rrpFutureAdjusments = document.getElementById('rrp-future-adjusments').outerHTML
        const rrpFutureDestination = document.getElementById('rrp-future-destination').outerHTML
        const rrpFutureInflow = document.getElementById('rrp-future-inflow').outerHTML
        const rrpFutureOutflow = document.getElementById('rrp-future-outflow').outerHTML
        const rrpFutureAcctSummary = document.getElementById('rrp-future-acct-summary').outerHTML
        const rrpFutureSummaryCashFlow = document.getElementById('rrp-future-summary-cash-flow').outerHTML
        const rrpFutureFiaReport = document.getElementById('rrp-future-fia-report').outerHTML
        const rrpFutureInsurance = document.getElementById('rrp-future-insurance').outerHTML
        const disclosures = document.getElementById('roadmap-report-page-disclosures')

        const pagesHtmlRoadmapReport =
            rrpGetStarted.replace('id="tom-hegna-video"', 'href="https://www.youtube.com/embed/G9tiZyYSuF0?autoplay=1&controls=0&rel=0"') +
            rrpWelcome +
            rrpIncomeTaxDebtCharts +
            rrpAccumulationChart +
            rrpDistributionChart +
            rrpVolatilityBufferChart +
            rrpClientSpouseTaxSettings +
            rrpPlanInputAccounts +
            rrpPlanInputIncomes +
            rrpPlanInputGoals +
            rrpCurrentDestination +
            rrpFutureAdjusments +
            rrpFutureDestination +
            rrpFutureInflow +
            rrpFutureOutflow +
            rrpFutureAcctSummary +
            rrpFutureSummaryCashFlow +
            rrpFutureFiaReport +
            rrpFutureInsurance;

        const roadmapReportHtml = `
        <head>
            <style>
                body {
                    font-family: "Verdana", sans-serif;
                }
                @page {
                    size: 1054px 635px;
                    font-family: "Roboto", sans-serif;
                }
                @page landscape {
                    prince-rotate-body: 270deg;
                    prince-shrink-to-fit: auto
                }
                
                .big {
                    height: 80%;
                    page: big-table;
                }
                
                .prepare-by {
                    font-size: 12px;
                    text-align: center;
                    margin-top: 20px !important;
                }
            </style>
        </head>
        <body> 
            ${pagesHtmlRoadmapReport + disclosures.outerHTML} 
        </body>`

        generatePDF(roadmapReportHtml.replace(/"/g, "'"), props.client.id, props.token).then((response) => {
            if (response.status === 200) {
                window.open(`${SERVER_URL}/api/ifw/client/export-pdf?fileName=${response.data}`);
            }
            setState((v) => ({ ...v, loading: false }))
        });
    }

    //COMPONENTS
    const Banner = (props) => {
        return (
            <div style={{ height: '28px', width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', backgroundColor: blueColor1 }}>
                <h3 style={{ margin: 0, color: 'white', fontFamily: familyFont }}> {props.text}</h3>
            </div>
        )
    }
    const ElementLi = (props) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ height: '11px', width: '11px', borderRadius: '50px', backgroundColor: blueColor1, color: 'white', fontSize: '7pt', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >{props.number}</div>
                <div style={{ marginLeft: '0.5em', fontSize: '10pt' }}> {props.text} </div>
            </div>
        )
    }

    const ImagePresentationTitle = (props) => {
        return (
            <div style={{ width: '50%', ...props.style }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <p
                        style={{ display: 'inline-block', fontSize: '11pt', color: grey, fontWeight: 'bold', margin: '5px 0', ...props.textStyle, ...props.styleTextLeftUp }}
                        className='typography-chart-images-titles'
                    > {props.textLeftUp}
                    </p>
                    <p
                        style={{ fontSize: '11pt', color: blueColor1, textDecoration: 'underline', fontWeight: 'bold', margin: '5px 5px', ...props.textStyle, ...props.styleTextRigthUp }}
                        className='typography-chart-images-titles'
                    > {props.textRigthUp}
                    </p>
                </div>
                <img src={props.image} style={{ width: '100%', height: '100%', objectFit: 'fill', ...props.imageStyle }} />
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <p
                        style={{ display: 'inline-block', fontSize: '7.5pt', color: grey, fontWeight: 'bold', margin: '5px 2px', ...props.textStyle, ...props.styleTextLeftDown }}
                        className='typography-chart-images-sub-titles'
                    >
                        {props.textLeftDown}
                    </p>
                    <p
                        style={{ display: 'inline-block', fontSize: '7.5pt', color: blueColor1, textDecoration: 'underline', fontWeight: 'bold', margin: '5px 0px', ...props.textStyle, ...props.styleTextCenterDown }}
                        className='typography-chart-images-sub-titles'
                    >
                        {props.textCenterDown}
                    </p>
                    <p
                        style={{ fontSize: '7.5pt', fontWeight: 'bold', ...props.textStyle, ...props.styleTextRigthDown, margin: '5px 3px' }}
                        className='typography-chart-images-sub-titles'
                    >
                        {props.textRigthDown}
                    </p>
                </div>
            </div>
        )
    }

    const Box = (props) => {
        return (
            <div style={{ ...props.style, ...boxStyle }}>
                <span style={{ fontWeight: 'bold', fontSize: '7pt', marginBottom: '5px' }}> {props.text}</span>
                <span style={{ fontWeight: 'bold', fontSize: '10pt', color: blueColor1 }}>{props.number}</span>
            </div>
        )
    }

    const InputClientSpouse = (props) => {

        return (
            <>
                <label style={clientSpouseStyle}> {props.label}</label>
                <div style={inputClientStyle}>
                    {props.value}
                </div>
            </>)
    }

    const Page = (props) => {

        return (<>
            {props.showDivision && <Grid style={{ ...divisionStyle, width: '100%', marginTop: '40px', ...props.divisionStyle }}></Grid>}
            <Grid style={{ width: '90%', ...props.containerStyle }}>
                <div id={`${props.pageDescription}`}>
                    <div
                        className={'landscape-content'}
                        style={{ pageBreakBefore: "always" }}>
                        <PdfHeader style={{ marginTop: '-80px', ...props.headerStyle }} />
                        <Banner text={props.bannerText} />
                        {props.children}
                    </div>
                </div>

            </Grid>
        </>)
    }

    const defaultContent = <div style={{ fontSize: '10pt' }}>
        {props.currentPlanContentText}
    </div>

    const defaultFooter = <div style={{ fontSize: '10pt' }}>
        {props.currentPlanFooterText}
    </div>

    const TextPlanProbability90 = {
        title: <p style={{ color: '#007bef', display: 'inline-block', marginLeft: '5px' }}>very secure probability.  </p>
    }
    const TextPlanProbability7589 = {
        title: <p style={{ color: '#007bef', display: 'inline-block', marginLeft: '5px' }}>likely probability.  </p>
    }
    const TextPlanProbability75 = {
        title: <p style={{ color: '#007bef', display: 'inline-block', marginLeft: '5px' }}>uncertain probability.</p>
    }

    //CLASSES
    const containerPage1 = { display: 'flex', flexDirection: 'row' };
    const containerPage1Rigth = { width: '50%' }
    const containerPage1Left = { width: '50%' }
    const containerBlueBackground = { position: 'relative', width: '100%' }
    const centerImagesContainerStyle = { display: 'flex', flexDirection: 'row', justifyContent: 'center' }
    const centerElementsRightSide = {
        float: 'left',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '1',
        height: '120px', width: '250px',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        color: 'white'
    }
    const bottomRigthSide = {
        background: 'linear-gradient(180deg, rgba(213, 251, 243, 1) 0%, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 1) 100%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        width: '100%',
    }
    const cardTomHegna = {
        marginTop: '5px',
        width: '90%',
        height: '10em',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        background: 'linear-gradient(180deg, rgba(213, 251, 243, 1) 0%, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 1) 100%)'
    }
    const cardLeftSideTom = { height: '60%', width: '25%', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }
    const styleTextCardLi = { fontSize: '0.8em' }
    const containerPage2 = { display: 'flex', flexDirection: 'row', }

    const clientSpouseStyle = { fontWeight: '600', color: "#444", marginTop: "0.5em", marginBottom: "0.25em", display: "inline-block", fontSize: '10pt' }
    const inputClientStyle = { borderBottom: 'none', color: "#444", width: '80%', fontSize: '11pt' }
    const containerClientStyle = { width: '45%' }
    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }


    const divideStyleLine = { borderBottom: '1px solid grey', marginTop: '15px' }
    const styleUserName = { color: greenColor1, fontWeight: 'bold', fontSize: '14pt' }
    const rowStyle = { display: 'flex', flexDirection: 'row' }
    const smallRowStyle = { display: 'flex', flexDirection: 'row', fontSize: '8pt'}
    const boxStyle = { border: '1px solid grey', borderRadius: '6px', display: 'flex', flexDirection: 'column', padding: '12px' }
    const cellStyleFutureDestinationHeader = { fontSize: '12pt', color: 'grey', fontWeight: 'bold' }
    const cellStyleFutureDestinationContent = { fontSize: '10pt', fontWeight: 'bold' }
    const smallCellStyle = { fontSize: '8pt', fontWeight: 'normal'};
    const justifyStyleText = { textAlign: 'justify', textJustify: 'inter-word' }
    const textStyleRoadmaReport = { fontSize: '11pt' }
    const cellStyleDefaultColor = { backgroundColor: 'rgba(213, 251, 243, 1)' }
    const cellStyleDefaultCashFlow = { textAlign: 'left', fontSize: '8pt' }
    const divisionStyle = { borderBottom: '1px dashed rgb(177, 177, 177)' }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={"lg"}
            open={open}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogTitle>{"Roadmap Report"}</DialogTitle>

            <Grid >
                <VideoModalTomHegna isOpen={isOpen} closeModal={closeModal} />
                <Grid item xs={9} ml={3} style={rowStyle}>
                    <Grid>
                        <Button variant="outlined" onClick={handleClose}> Close </Button>
                        <Button
                            onClick={downloadReport}
                            style={{ marginLeft: '30px' }}
                            disabled={state.loading}
                            className={state.loading ? "disabled-button" : ""}
                        > Download </Button>
                    </Grid>
                    <Loader size={"35px"} show={state.loading} />

                </Grid>

                <Grid item xs={12} mt={14} display={'flex'} >
                    <Grid container style={{ diplay: 'flex', justifyContent: 'center', fontFamily: familyFont }}>
                        <Page
                            showDivision={false}
                            containerStyle={{}}
                            pageDescription={"rrp-GetStarted"}
                            headerStyle={{}}
                            bannerText={"GET STARTED"}
                        >
                            <div style={{ ...containerPage1, height: '370px' }}>
                                <img
                                    style={containerPage1Left}
                                    src={START_IMAGE}
                                />
                                <div style={containerPage1Rigth}>
                                    <div style={containerBlueBackground}>
                                        <div style={centerElementsRightSide}>
                                            {removeSpaces(props.client.firstName)}, Welcome to Your <br /> INSTITUTE OF FINANCIAL WELLNESS<br />  Retirement Roadmap Experience!
                                        </div>
                                        <img src={BLUE_BACKGROUND} title={"blue_background"} alt={"blue_background"} style={{ width: '100%' }} />
                                    </div>


                                    <div style={bottomRigthSide}>
                                        <p className='never-say-never' style={{ textAlign: 'center', fontSize: '10pt', color: blueColor1 }}> When It Comes To Financial Decisions; <br />Never Say "Never", Never says "Always" ...It Depends! </p>
                                        <a style={{ color: blueColor1, fontSize: '11pt', textDecoration: 'underline' }}
                                            id='tom-hegna-video'
                                            onClick={openModal}
                                            target={"_blank"}
                                        >Click to Watch Tom Hegna's Welcome Video</a>

                                        <div style={cardTomHegna}>
                                            <div style={cardLeftSideTom}>
                                                <img src={TOM_HEGNA} style={{ height: '70%', margin: '0', objectFit: 'contain' }} />
                                                <p style={{ margin: 0, fontSize: '10pt' }}> Tom Hegna</p>
                                            </div>
                                            <div>
                                                <ul>
                                                    <li style={styleTextCardLi}>Best Selling Author</li>
                                                    <li style={styleTextCardLi}>Renowned Global Retirement Spokesperson</li>
                                                    <li style={styleTextCardLi}>30+ Years Veteran Fortune 100 Executive in Retirement Planning</li>
                                                    <li style={styleTextCardLi}>Non-Client Paid Endorser</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"prepare-by"} style={{fontSize: '14px', textAlign: 'center', marginTop: '70px'}}>Prepared by {fpName}</div>
                        </Page>

                        <Page
                            showDivision={true}
                            divisionStyle={{ marginTop: '20px' }}
                            containerStyle={{ marginTop: '110px' }}
                            pageDescription={"rrp-Welcome"}
                            headerStyle={{}}
                            bannerText={""}
                        >
                            <div style={{ ...containerPage2, height: '370px' }}>
                                <div style={{ width: '100%', ...justifyStyleText }}>
                                    <p style={{ fontSize: '20pt', color: '#939598' }}>
                                        Dear {`${removeSpaces(firstLetterUpperCase(props.client.firstName))}${spouse != null ? ` and ${firstLetterUpperCase(spouse.firstName)},` : ','} `}
                                    </p>
                                    <div style={{ marginLeft: '1.5em' }}>
                                        <p style={{ fontSize: '10pt' }}>Congratulations, on continuing your journey towards greater financial clarity and confidence so you can live your best life in retirement. Your IFW Retirement Roadmap experience, guided by the knowledge and experience of your IFW Financial Professional will help you achieve three critical things: </p>
                                        <div style={{ marginLeft: '1.5em' }}>
                                            <ElementLi number={1} text={"Potentially lower or eliminate your taxes in retirement."} />
                                            <ElementLi number={2} text={"Mitigate the effects of market volatility on your portfolio."} />
                                            <ElementLi number={3} text={"Strategies to improve your chances of not running out of money in retirement."} />
                                        </div>
                                        <p style={{ fontSize: '10pt' }}>We are excited to support you and provide you clarity and confidence in your retirement!
                                            After you review your IFW Retirement Roadmap with your IFW Financial Professional, he/she will show you options that could improve your situation. The suggestions your IFW Financial Professional makes will be aligned with The Institute of Financial Wellness' philosophy that when it comes to financial decisions; Never Say "Never", Never says "Always" ...It Depends!
                                        </p>
                                    </div>
                                    <div style={{ backgroundColor: '#43ebca', }}>
                                        <div style={{ marginLeft: '1.5em', marginTop: '0.5em' }}>
                                            <p style={{ color: '#157ee8', fontSize: '10pt' }}>
                                                Remember, there is no one size fits all solution to achieving your financial goals, and you deserve a customized strategy that makes sense for you.
                                            </p>
                                        </div>
                                    </div>
                                    <div style={{ marginLeft: '1.5em' }}>
                                        <p style={{ fontSize: '10pt' }}> On behalf of the Institute of Financial Wellness, I want to wish you the very best on your journey to living your best life in retirement. <b> Let's Get There, Together!</b></p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: '30px', marginLeft: '1.5em' }}>
                                        <div style={{ marginRight: '10px' }}>
                                            <p style={{ fontSize: '9pt', margin: 0 }}>Sincerely, </p>
                                            <p style={{ fontSize: '9pt', margin: 0 }}>Erik Sussman CFP, ChFC, CLU </p>
                                            <p style={{ fontSize: '9pt', margin: 0 }}>CEO & Founder, IFW</p>
                                        </div>
                                        <img src={ERIK_SUSSMAN} style={{ height: '50px' }} />
                                    </div>

                                </div>
                            </div>
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                            pageDescription={"rrp-income-tax-debt-charts"}
                            headerStyle={{}}
                            bannerText={"Income Tax Chart & US Debt Chart"}
                        >
                            <div style={{ ...centerImagesContainerStyle, height: '360px' }} >
                                <img src={PAGE3_LEFTSIDE} style={{ width: '50%', height: '364px', objectFit: 'fill', ...props.imageStyle }} />
                                <img src={PAGE3_RIGTHSIDE} style={{ width: '50%', height: '100%', objectFit: 'fill', ...props.imageStyle }} />

                            </div>
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-accumulation-chart"}
                            headerStyle={{}}
                            bannerText={"Accumulation Chart"}
                        >
                            <div style={centerImagesContainerStyle} >
                                <ImagePresentationTitle
                                    textLeftUp={"WHEN YOU ARE ACCUMULATING MONEY,"}
                                    textRigthUp={"THE SEQUENCE OF RETURNS DOESN'T MATTER"}
                                    image={ACCUMULATION_CHART}
                                    style={{ width: '100%', height: '100%' }}
                                    imageStyle={{ width: '100%', height: '100%' }}
                                    textLeftDown={"End Result: During Accumulation"}
                                    textCenterDown={"The Sequence of Returns Does Not Affect"}
                                    textRigthDown={"Your Final Account Value"}


                                />
                            </div>
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-distribution-chart"}
                            headerStyle={{}}
                            bannerText={"Distribution Chart"}
                        >
                            <div style={centerImagesContainerStyle} >
                                <ImagePresentationTitle
                                    textLeftUp={"WHEN YOU ARE DISTRIBUTING MONEY,"}
                                    textRigthUp={"THE SEQUENCE OF RETURNS MEANS EVERYTHING"}
                                    image={DISTRIBUTION_CHART}
                                    style={{ width: '100%', height: '100%' }}
                                    imageStyle={{ width: '100%', height: '100%' }}
                                    textLeftDown={"End Result: During Distribution"}
                                    textCenterDown={"The Sequence of Returns Will Significantly Affect Your Final Account Value"}
                                    textRigthDown={"and Potentially Cause You to Run Out of Money"}
                                />
                            </div>
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-volatility-buffer-chart"}
                            headerStyle={{}}
                            bannerText={"Volatility Buffer Chart"}
                        >

                            <p
                                style={{ fontSize: '11pt', color: grey, fontWeight: 'bold', margin: '5px 0', ...props.textStyle, ...props.styleTextLeftUp }}
                                className='typography-chart-images-titles'
                            >DON'T WITHDRAW MONEY DURING MARKET DOWN YEARS</p>
                            <div style={{ ...centerImagesContainerStyle, height: '340px' }} >
                                <img src={VOLATILITYBUFFER_LEFTSIDE} style={{ width: '50%', height: '100%', objectFit: 'fill', ...props.imageStyle }} />
                                <img src={VOLATILITYBUFFER_RIGTHSIDE} style={{ width: '50%', height: '100%', objectFit: 'fill', ...props.imageStyle }} />
                            </div>
                            <div
                                style={{ display: 'flex', flexDirection: 'column', margin: 0 }}
                            >
                                <p
                                    style={{ fontSize: '7.5pt', color: grey, fontWeight: 'bold', margin: '5px 0', ...props.textStyle, ...props.styleTextLeftUp }}
                                    className='typography-chart-images-sub-titles'
                                >Action: Access Money from the Volatility Buffer (safe bucket) when the growth bucket is down.</p>
                                <p
                                    style={{ fontSize: '7.5pt', color: blueColor1, textDecoration: 'underline', fontWeight: 'bold', margin: '5px 0', ...props.textStyle, ...props.styleTextLeftUp }}
                                    className='typography-chart-images-sub-titles'
                                >End Result: Your Portfolio Has Time To Recover Lowering Your Risk Of Running Out Of Money</p>
                            </div>

                        </Page>
                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-client-spouse-tax-settings"}
                            headerStyle={{}}
                            bannerText={""}
                        >
                            <div style={{ height: '360px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px', marginBottom: '15px' }}>
                                    <span style={styleUserName}> {props.client.firstName} {props.client.lastName} </span>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', justifyContent: 'center' }}>
                                    <Box style={{ width: '22%', marginRight: '4%' }} text={"Non-Qualified Assets"} number={currencyFormatNoDecimals(currentPlanInflow?.assumptions.nonQualifiedAssets)} />
                                    <Box style={{ width: '22%', marginRight: '4%' }} text={"Pre-Tax Assets"} number={currencyFormatNoDecimals(currentPlanInflow?.assumptions.preTaxAssets)} />
                                    <Box style={{ width: '22%' }} text={"Tax Free Accounts"} number={currencyFormatNoDecimals(currentPlanInflow?.assumptions.taxFreeAccounts)} />
                                </div>
                                <div style={divideStyleLine}> </div>

                                <h2 style={{ ...subSectionStyle, margin: '5px 0' }}> {"PERSONAL INFORMATION"} </h2>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', margin: '0' }}>
                                    <div style={containerClientStyle}>
                                        <h2 style={{ ...subSectionStyle, margin: '5px 0' }}> {"Client"}</h2>
                                        <InputClientSpouse value={props.client.firstName} label={"First Name"} />
                                        <InputClientSpouse value={props.client.lastName} label={"Last Name"} />
                                        <InputClientSpouse value={props.client.age} label={"Age"} />
                                        <InputClientSpouse value={props.client.retirementAge} label={"Target Retired Date"} />
                                        <InputClientSpouse value={props.client.isMarried ? "Married" : "Single"} label={"Filing Status"} />
                                    </div>
                                    {spouse != null && (
                                        <div style={containerClientStyle}>
                                            <h2 style={{ ...subSectionStyle, margin: '5px 0' }}> {"Spouse"}</h2>
                                            <InputClientSpouse label={"First Name "} value={spouse.firstName} />
                                            <InputClientSpouse label={"Last Name"} value={spouse.lastName} />
                                            <InputClientSpouse label={"Age"} value={spouse.age} />
                                            <InputClientSpouse label={"Target Retire Date"} value={spouse.retirementAge} />
                                        </div>
                                    )}

                                    <div style={containerClientStyle}>
                                        <h2 style={{ ...subSectionStyle, margin: '5px 0' }}> {"Tax Settings"}</h2>
                                        <InputClientSpouse label={"COLA "} value={`${planInput?.assumptions?.cola?.toFixed(2)}%`} />
                                        <InputClientSpouse label={"SS COLA "} value={`${planInput?.assumptions?.ssCola?.toFixed(2)}%`} />
                                        <InputClientSpouse label={"State Taxes"} value={`${planInput?.assumptions?.stateTax?.toFixed(2)}%`} />
                                        <InputClientSpouse label={"Capital Gain Taxes"} value={`${planInput?.assumptions?.capitalGainsTax?.toFixed(2)}%`} />
                                        <InputClientSpouse label={"FICA Tax"} value={`${planInput?.assumptions?.ficaTax?.toFixed(2)}%`} />
                                    </div>
                                </div>
                            </div>
                        </Page>
                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-plan-input-accounts"}
                            headerStyle={{}}
                            bannerText={""}>
                            <Accounts accounts={planInput?.accounts} />
                        </Page>
                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-plan-input-incomes"}
                            headerStyle={{}}
                            bannerText={""}>
                            <Incomes incomes={planInput?.incomes} />
                        </Page>
                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-plan-input-goals"}
                            headerStyle={{}}
                            bannerText={""}>
                            <Goals goals={planInput?.goals} />
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-current-destination"}
                            headerStyle={{}}
                            bannerText={"CURRENT DESTINATION"}>

                            <div style={{ ...rowStyle, justifyContent: 'center', width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '48%', marginRight: '2%' }}>
                                    <div style={{ ...rowStyle, alignItems: 'center', width: '100%' }}>
                                        <span style={{ ...styleUserName, width: '35%' }}> {props.client.firstName} {props.client.lastName} </span>
                                    </div>
                                    <div style={divideStyleLine}> </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', }}>
                                        <div style={{ width: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                            <GraphicPie
                                                id={"current-plan-id"}
                                                value={props.successProbabilityCurrent}
                                                width={100}
                                                innerRadius={14}
                                                numberDistanceX={-5}
                                                fontSizeNumber={25}
                                                symbolDistanceX={props.successProbabilityCurrent >= 100 ? 16 : 12}
                                                symbolDistanceY={12}
                                                fontSizeSymbol={16}
                                            />
                                        </div>
                                        <div style={{ width: '80%', marginLeft: '10px', fontSize: '12pt' }}>
                                            <div style={{ ...rowStyle, fontSize: '10pt' }}>
                                                {props.successProbabilityCurrent >= 90 && (
                                                    <> <p> The analysis has returned a </p> {TextPlanProbability90.title} </>
                                                )}
                                                {props.successProbabilityCurrent >= 75 && props.successProbabilityCurrent <= 89.9 && (
                                                    <><p> The analysis has returned a </p>{TextPlanProbability7589.title}</>
                                                )}
                                                {props.successProbabilityCurrent <= 74.9 && (
                                                    <><p> The analysis has returned a </p>{TextPlanProbability75.title}</>
                                                )}
                                            </div>
                                            <div style={justifyStyleText}>

                                                {defaultContent}
                                                {defaultFooter}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: '48%', marginLeft: '2%' }}>
                                    <div className={"table"} style={{ ...boxStyle, marginBottom: '10px' }}>
                                        <table style={{ width: '100%', textAlign: 'left' }}>
                                            <thead>
                                                <tr>
                                                    <th>Year</th>
                                                    <th>Age</th>
                                                    <th style={{ color: blueColor1 }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.tableCurrent.map(item => {
                                                    return (
                                                        <tr key={item.age}>
                                                            <th style={{ color: 'grey' }}>{item.year}</th>
                                                            <th style={{ color: 'grey' }}>{item.age}</th>
                                                            <th style={{ color: blueColor1 }}>{item.endingValue}</th>
                                                        </tr>
                                                    )
                                                })}

                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ ...boxStyle }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: '10pt' }}> $ Paid in Total Taxes</span>
                                            <span style={{ fontSize: '10pt', color: blueColor1, fontWeight: 'bold' }}> {currencyFormatNoDecimals(props.totalTaxesPaidCurrent)}</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: '7pt' }}> SS Taxes</span>
                                            <span style={{ fontSize: '7pt' }}>{currencyFormatNoDecimals(props.totalSSCurrent)} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-future-adjusments"}
                            headerStyle={{}}
                            bannerText={"Future Adjustments"}>
                            <FiaTransfers fiaTransfers={planInput?.fiaTransfers} accounts={planInput?.accounts} />
                            <ViolatilityInsuranceTransfers insuranceTransfers={planInput?.insuranceTransfers} accounts={planInput?.accounts} />
                            <InsuranceTransfers insuranceTransfers={planInput?.insuranceTransfers} accounts={planInput?.accounts} />
                            <RothConversion rothTransfers={planInput?.rothTransfers} accounts={planInput?.accounts} />
                            <FutureGoals goals={planInput?.spendingGoals} />
                        </Page>

                        {isFutureDestinationLocked ?
                            <div id={"rrp-future-destination"}> </div> :
                            <Page
                                showDivision={true}
                                containerStyle={{ marginTop: '120px' }}
                                pageDescription={"rrp-future-destination"}
                                headerStyle={{}}
                                bannerText={"FUTURE DESTINATION"}>
                                <div className={"Future destintaion"} style={{ width: '100%', ...rowStyle }}>
                                    <div style={{ margin: '2em 0 0 0', width: '35%', marginRight: '2%', ...justifyStyleText, display: 'flex', flexDirection: 'column' }} >
                                        <span style={{ ...styleUserName, width: '100%' }}> {props.client.firstName} {props.client.lastName} </span>
                                        <div style={{ ...divideStyleLine, margin: '12px 0' }}> </div>
                                        <span style={{ fontSize: '12pt' }}>
                                            {props.futureDestinationText}
                                        </span>
                                    </div>
                                    <div style={{ width: '60%', marginLeft: '2%' }}>
                                        <div className={'graph-titles'} style={rowStyle}>
                                            <div style={{ width: '20%', marginLeft: '7px' }}></div>
                                            <div style={{ width: '30%', marginLeft: '7px' }}><span style={{ ...cellStyleFutureDestinationHeader, color: greenColor1 }}> CURRENT </span></div>
                                            <div style={{ width: '30%', marginLeft: '7px' }}><span style={{ ...cellStyleFutureDestinationHeader, color: greenColor1 }}> FUTURE </span></div>
                                            <div style={{ width: '20%', marginLeft: '7px' }}></div>
                                        </div>
                                        <div className={"table"} style={{ ...boxStyle, marginBottom: '10px' }}>
                                            <div style={{ ...rowStyle, marginBottom: '10px' }}>
                                                <div style={{ ...cellStyleFutureDestinationHeader, ...rowStyle, fontSize: '9pt', width: '20%', alignItems: 'center', }}><span> PROBABILITY OF SUCCESS </span> </div>
                                                <div style={{ width: '30%', marginLeft: '8px' }}>
                                                    <GraphicPie
                                                        id={"current-plan-id"}
                                                        value={props.successProbabilityCurrent}
                                                        width={100}
                                                        innerRadius={14}
                                                        numberDistanceX={-5}
                                                        fontSizeNumber={25}
                                                        symbolDistanceX={props.successProbabilityCurrent >= 100 ? 16 : 12}
                                                        symbolDistanceY={12}
                                                        fontSizeSymbol={16}
                                                    />
                                                </div>
                                                <div style={{ width: '30%' }}>
                                                    <GraphicPie
                                                        id={"future-plan-id"}
                                                        value={props.successProbabilityFuture}
                                                        width={100}
                                                        innerRadius={14}
                                                        numberDistanceX={-5}
                                                        fontSizeNumber={25}
                                                        symbolDistanceX={props.successProbabilityFuture >= 100 ? 16 : 12}
                                                        symbolDistanceY={12}
                                                        fontSizeSymbol={16}
                                                    />
                                                </div>
                                                <div style={{ width: '26%' }}> </div>
                                            </div>
                                            <div className={'header'} style={rowStyle}>
                                                <span style={{ ...cellStyleFutureDestinationHeader, width: '10%' }}>Year </span>
                                                <span style={{ ...cellStyleFutureDestinationHeader, width: '10%' }}>Age </span>
                                                <span style={{ ...cellStyleFutureDestinationHeader, width: '30%' }}>Total Current </span>
                                                <span style={{ ...cellStyleFutureDestinationHeader, width: '30%' }}>Total Future</span>
                                                <span style={{ ...cellStyleFutureDestinationHeader, width: '20%' }}>Change</span>
                                            </div>
                                            {props.tableCurrentFuture.map(item => {
                                                return (
                                                    <div key={item.age} className={'content'} style={rowStyle}>
                                                        <span style={{ ...cellStyleFutureDestinationContent, width: '10%' }}>{item.year} </span>
                                                        <span style={{ ...cellStyleFutureDestinationContent, width: '10%' }}>{item.age}</span>
                                                        <span style={{ ...cellStyleFutureDestinationContent, width: '30%', color: "grey" }}>{item.totalCurrent} </span>
                                                        <span style={{ ...cellStyleFutureDestinationContent, width: '30%', color: blueColor1 }}>{item.totalFuture}</span>
                                                        <span style={{ ...cellStyleFutureDestinationContent, width: '20%', color: greenColor1 }}>{item.increase}</span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div style={{...boxStyle}}>
                                            <div className={'header'} style={rowStyle}>
                                                <span style={{
                                                    ...cellStyleFutureDestinationHeader,
                                                    width: '10%'
                                                }}>Year </span>
                                                <span style={{
                                                    ...cellStyleFutureDestinationHeader,
                                                    width: '10%'
                                                }}>Age </span>
                                                <span style={{...cellStyleFutureDestinationHeader, width: '30%'}}>Total Current </span>
                                                <span style={{...cellStyleFutureDestinationHeader, width: '30%'}}>Total Future</span>
                                                <span style={{
                                                    ...cellStyleFutureDestinationHeader,
                                                    width: '20%'
                                                }}>Change</span>
                                            </div>
                                            {taxReportData.filter((item, index) => index === 10 || index === 20 || index === taxReportData.length-1).map((item, index) => {
                                                return (
                                                    <>
                                                        <div key={item.age} className={'content'} style={rowStyle}>
                                                            <span style={{
                                                                ...cellStyleFutureDestinationContent,
                                                                width: '10%'
                                                            }}>{item.year} </span>
                                                            <span style={{
                                                                ...cellStyleFutureDestinationContent,
                                                                width: '10%'
                                                            }}>{item.age}</span>
                                                            <span style={{
                                                                ...cellStyleFutureDestinationContent,
                                                                width: '30%',
                                                                color: "grey"
                                                            }}>{currencyFormatNoDecimals(item.currentTotalTaxes)} </span>
                                                            <span style={{
                                                                ...cellStyleFutureDestinationContent,
                                                                width: '30%',
                                                                color: blueColor1
                                                            }}>{currencyFormatNoDecimals(item.futureTotalTaxes)}</span>
                                                            <span style={{
                                                                ...cellStyleFutureDestinationContent,
                                                                width: '20%',
                                                                color: greenColor1
                                                            }}>{currencyFormatNoDecimals(item.diffTotalTaxes)}</span>
                                                        </div>
                                                        <div key={item.age} className={'content'} style={smallRowStyle}>
                                                            <span style={{
                                                                ...smallCellStyle,
                                                                width: '10%'
                                                            }}></span>
                                                            <span style={{
                                                                ...smallCellStyle,
                                                                width: '10%'
                                                            }}></span>
                                                            <span style={{
                                                                ...smallCellStyle,
                                                                width: '30%',
                                                                color: "grey"
                                                            }}>{currencyFormatNoDecimals(item.currentSocialSecurity)} </span>
                                                            <span style={{
                                                                ...smallCellStyle,
                                                                width: '30%',
                                                                color: "grey"
                                                            }}>{currencyFormatNoDecimals(item.futureSocialSecurity)}</span>
                                                            <span style={{
                                                                ...smallCellStyle,
                                                                width: '20%',
                                                                color: greenColor1
                                                            }}>{currencyFormatNoDecimals(item.diffSocialSecurity)}</span>
                                                        </div>
                                                    </>)
                                            })}
                                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                                <span style={{width: '19%', marginRight: '3px', fontSize: '10pt'}}> $ Paid in Total Taxes</span>
                                                <span style={{
                                                    width: '30%',
                                                    fontSize: '10pt',
                                                    color: 'grey',
                                                    fontWeight: 'bold'
                                                }}> {currencyFormatNoDecimals(props.totalTaxesPaidCurrent)}</span>
                                                <span style={{
                                                    width: '30%',
                                                    fontSize: '10pt',
                                                    color: blueColor1,
                                                    fontWeight: 'bold'
                                                }}> {currencyFormatNoDecimals(props.totalTaxesPaidFuture)}</span>
                                                <span style={{
                                                    width: '20%',
                                                    fontSize: '10pt',
                                                    color: greenColor1,
                                                    fontWeight: 'bold'
                                                }}> {currencyFormatNoDecimals(props.totalTaxesPaidFuture - props.totalTaxesPaidCurrent)}</span>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between'
                                            }}>
                                                <span style={{width: '20%', fontSize: '7pt'}}> SS Taxes</span>
                                                <span style={{
                                                    width: '30%',
                                                    fontSize: '7pt'
                                                }}>{currencyFormatNoDecimals(props.totalSSCurrent)} </span>
                                                <span style={{
                                                    width: '30%',
                                                    fontSize: '7pt'
                                                }}>{currencyFormatNoDecimals(props.totalSSFuture)} </span>
                                                <span style={{
                                                    width: '20%',
                                                    fontSize: '7pt'
                                                }}>{currencyFormatNoDecimals(props.totalSSFuture - props.totalSSCurrent)} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Page>
                        }

                        <Page
                            showDivision={true}
                            containerStyle={{marginTop: '120px'}}
                            pageDescription={"rrp-future-inflow"}
                            headerStyle={{}}
                            bannerText={"Inflow"}>
                            <TableCashFlow
                                headers={[
                                    <th style={{...cellStyleDefaultCashFlow, ...cellStyleDefaultColor}}>{"Year"}</th>,
                                    <th style={{...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Client/Spouse"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Payroll"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Social Security"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Pension"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Other Income"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Tax Deferred Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Taxable Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Tax Exempt Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"FIA Withdrawal"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Total Inflows"}</th>
                                ]}
                                values={cashInflow.map(row => {
                                    return <tr>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{row.year}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{mergeClientCoClientAge(row.clientAge, row.coClientAge)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.payroll)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.socialSecurity)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.pension)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.other)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxDeferredDistributions)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxableDistributions)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxExemptDistributions)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.fiaWithdrawal)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.totalInFlow)}</th>

                                    </tr>
                                })}
                            />
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-future-outflow"}
                            headerStyle={{}}
                            bannerText={"Outflow"}>

                            <TableCashFlow
                                headers={[
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Year"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Client/Spouse"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Retirement Budget"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Social Security Tax"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Capital Gains Tax"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Income Tax"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Total Outflows"}</th>,
                                ]}
                                values={cashOutflow.map(row => {
                                    return <tr>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{row.year}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{mergeClientCoClientAge(row.clientAge, row.coClientAge)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.retirementBudget)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.socialSecurityTax)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.capitalGainsTax)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.incomeTax)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.totalOutFlow)}</th>
                                    </tr>
                                })}
                            />

                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-future-acct-summary"}
                            headerStyle={{}}
                            bannerText={"Accounts Summary"}>

                            <TableCashFlow
                                extraHeaderRow={true}
                                extraHeaderRowColSpan={[
                                    { col: 1 },
                                    { col: 1 },
                                    { className: 'extra-row-cash-flow', col: 2, title: 'Taxable' },
                                    { className: 'extra-row-cash-flow', col: 2, title: 'Tax Deferred' },
                                    { className: 'extra-row-cash-flow', col: 2, title: 'Tax Exempt' },
                                    { className: 'extra-row-cash-flow', col: 2, title: 'RILA/Vol Buff FIA' },
                                    { className: 'extra-row-cash-flow', col: 2, title: 'Vol Buff Ins' },
                                    { className: 'extra-row-cash-flow', col: 1 },
                                    { col: 1 },
                                    { col: 1 },
                                    { col: 1 },
                                ]}
                                headers={[
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Year"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Client/Spouse"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Acct Balance"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Acct Balance"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Acct Balance"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Acct Balance"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Net Cash Value"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Port Returns"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"RILA/FIA Return"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Cash Val Return"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Total Account Value"}</th>,


                                ]}
                                values={accountsSummary.map(row => {
                                    return <tr>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{row.year}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{mergeClientCoClientAge(row.clientAge, row.coClientAge)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxableAccountBalance)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxableAccountGrossDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxDeferredAccountBalance)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxDeferredAccountGrossDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxExemptAccountBalance)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.taxExemptAccountGrossDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.fiaAccountBalance)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.fiaAccountGrossDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.insuranceNetCashValue)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.insuranceGrossDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{formatNumberToPercentage(row.portfolioReturns, 2)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{formatNumberToPercentage(row.fiaIndexReturn, 2)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{formatNumberToPercentage(row.insuranceCashValueReturn, 2)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.totalAccountValue)}</th>
                                    </tr>
                                })}
                            />
                        </Page>

                        <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-future-summary-cash-flow"}
                            headerStyle={{}}
                            bannerText={"Summary Cash Flow"}>

                            <TableCashFlow
                                rowStyle={{ fontSize: '11px' }}
                                extraHeaderRow={true}
                                extraHeaderRowColSpan={[
                                    { col: 1, className: '', title: '' },
                                    { col: 1, className: '', title: '' },
                                    { col: 1, className: '', title: '' },
                                    { col: 1, className: '', title: '' },
                                    { col: 1, className: '', title: '' },
                                    { col: 3, className: 'extra-row-cash-flow', title: 'Taxable' },
                                    { col: 2, className: 'extra-row-cash-flow', title: 'Tax Deferred' },
                                    { col: 2, className: 'extra-row-cash-flow', title: 'Tax Exempt' },
                                    { col: 2, className: 'extra-row-cash-flow', title: 'RILA/Vol Buff FIA' },
                                    { col: 1, className: 'extra-row-cash-flow', title: 'Vol Buff Ins' },
                                    { col: 1, className: 'extra-row-cash-flow', title: '' },
                                    { col: 1, className: '', title: '' },
                                    { col: 1, className: '', title: '' },
                                    { col: 1, className: '', title: '' },

                                ]}
                                headers={[
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Year"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Client/Spouse"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Beg Acct Value"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Total Inflows"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Total Outflows"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Excess Income"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Contr"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Taxable Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Contr"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Tax Deferred Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Contr"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Gross Tax Exempt Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Contr"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"FIA Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Ins Dist"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Port Returns"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"RILA/FIA Return"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Cash Value Return"}</th>,
                                    <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Cumulative Wealth"}</th>

                                ]}
                                values={cashFlowSummary.map(row => {
                                    return <tr>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px', fontSize: '10px' }}>{row.year}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px', fontSize: '10px' }}>{mergeClientCoClientAge(row.clientAge, row.coClientAge)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.beginningAccountValue)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.totalInflow)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.totalOutflow)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.excessIncome)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.taxableAccountContribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.grossTaxableDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.taxDeferredAccountContribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.grossTaxDeferredDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.taxExemptAccountContribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.grossTaxExemptDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.fiaAccountContribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.fiaDistribution)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.insuranceAccountDistribtuion)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{formatNumberToPercentage(row.portfolioReturns, 2)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{formatNumberToPercentage(row.fiaIndexReturn, 2)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{formatNumberToPercentage(row.insuranceCashValueReturn, 2)}</th>
                                        <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px', fontSize: '10px' }}>{currencyFormatNoDecimals(row.cumulativeWealth)}</th>
                                    </tr >
                                })}
                            />
                        </Page >


                        {props.showFiaReport ? <Page
                            showDivision={true}
                            containerStyle={{ marginTop: '120px' }}
                            pageDescription={"rrp-future-fia-report"}
                            headerStyle={{}}
                            bannerText={"FIA Report"}>

                            {fiaReports.map(fiaReport => {
                                return (
                                    <TableCashFlow
                                        extraHeaderRow={true}
                                        extraHeaderRowColSpan={[
                                            { col: 9, className: 'extra-row-cash-flow', title: 'Guaranteed Income FIA' },
                                            { col: 2, className: 'extra-row-cash-flow', title: 'Income Rider' },
                                        ]}
                                        headers={[
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"End Of Contract Year"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Client/Spouse"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Net Premium + Bonus"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Credited Interest"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Accumulation Values"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Death Benefits"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Beginning of Year Lifetime Withdrawal Percent"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Withdrawal (Contract)"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Benefit Base"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Rollup Amount"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Withdrawal (Income Rider)"}</th>
                                            // <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Age"}</th>,
                                            // <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Calender Year"}</th>,
                                            // <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Cash Surrender Value"}</th>,
                                        ]}
                                        values={fiaReport.map(row => {
                                            return <tr>
                                                <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{row.endOfContractYear}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{mergeClientCoClientAge(row.coClientAge, row.clientAge)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.netPremiumAndBonus)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.creditedInterest)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.accumulationValue)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.deathBenefit)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{formatNumberToPercentage(row.beginningOfYearlifetimeWithdrawalPercent)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.withdrawalContract)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.benefitBase)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.rollupAmount)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.withdrawalIncomeRider)}</th>
                                                {/* <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{row.age}</th> */}
                                                {/* <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.calenderYear)}</th> */}
                                                {/* <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{currencyFormatNoDecimals(row.cashSurrenderValue)}</th> */}

                                            </tr >
                                        })}
                                    />
                                )
                            })}
                        </Page > : <div id={'rrp-future-fia-report'}> </div>}
                        {insuranceReport.length > 0 ?
                            <Page
                                showDivision={true}
                                containerStyle={{ marginTop: '120px' }}
                                pageDescription={"rrp-future-insurance"}
                                headerStyle={{}}
                                bannerText={"Insurance"}>
                                {insuranceReport.map((insurance, idx) => {
                                    return <TableCashFlow
                                        key={idx}
                                        headers={[
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Year"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Client/Spouse"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Premium Outlay"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Distribution"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Net Cash Value"}</th>,
                                            <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor }}>{"Net Death Benefits"}</th>
                                        ]}
                                        values={insurance.map(row => {
                                            return <tr>
                                                <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{row.year}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, ...cellStyleDefaultColor, paddingLeft: '3px' }}>{mergeClientCoClientAge(row.clientAge, row.coClientAge)}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{row.premiumOutlay}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{row.distribution}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{row.netCashValue}</th>
                                                <th style={{ ...cellStyleDefaultCashFlow, paddingLeft: '3px' }}>{row.netDeathBenefits}</th>
                                            </tr >
                                        })}
                                    />
                                })}
                            </Page > : <div id={'rrp-future-insurance'}> </div>
                        }



                        <Grid style={{ borderBottom: '1px dashed rgb(177, 177, 177)', width: '100%', marginTop: '40px' }}></Grid>
                        <Grid style={{ width: '90%', marginTop: '50px' }}>
                            <div id={'roadmap-report-page-disclosures'} style={{ pageBreakBefore: "always" }}>
                                <div>
                                    <span> <b> Disclosure </b> </span>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        This presentation and the information contained herein is Confidential and shall be kept confidential. Delivery of this presentation to anyone other than the recipient or an investment professional referred to recipient by IFW is unauthorized and any reproduction of this presentation, in whole or in part, or any attempt to divulge its contents, in whole or in part, without the prior written consent of the Issuer is prohibited
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        This presentation has been prepared solely for the purpose of providing a preliminary introduction to the opportunity described in the presentation to assist recipients in deciding whether they wish to proceed with a further review of this opportunity. Information contained herein has been obtained from Morningstar, Inc. and other sources which are deemed reliable, but no representations or warranties are made by IFW or any of its affiliates, employees or representatives as to the accuracy or completeness of such information or any other information (whether written or oral) made available in connection with the presentation.  IFW has not independently verified any of the information set forth in this presentation. Only those particular representations  which may be made by investment professionals and issuers in a definitive agreement when, as and if it is executed, and subject to such limitations and restrictions as may be specified in the definitive agreement, will have any legal effect, and IFW is not responsible for such representations.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        The presentation uses the information provided by the recipient regarding assets, liabilities, goals, accounts, and other variables.  This information is a key input for the calculators and plans used by the presentation and should be derived from official account statements provided to the recipient by their account custodians.  This information should be reviewed periodically and updated whenever there is a change in information or circumstances.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        This presentation uses historical returns as a simplifying assumption used to model investment returns. It uses returns from the past to model returns going forward. However, in the real investment world, returns vary widely and therefore the past returns are not necessarily indicative of future returns. Therefore, one should not think that the historical returns used in this plan will necessarily be accurate going forward. The performance and analysis figures contained in this presentation are hypothetical and are for informational purposes only. IFW does not sell securities, and this presentation does not constitute a solicitation or an offer to sell any securities.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        This presentation does not constitute an offer or solicitation to sell or purchase any securities or insurance products. The information contained in this presentation does not purport to contain all of the information that a prospective purchaser may desire. In all cases, interested parties should conduct their own investigation and consult with their referral investment professional  to analyze the information contained herein. The information contained in this presentation is not to be used for any other purpose.
                                    </p>
                                </div>
                                <div style={{ pageBreakBefore: "always" }}>
                                    <span style={{ textDecoration: 'underline' }}> IFW Presentation Methodology  </span>
                                    <p >
                                        The presentation offers a financial planning tool that utilizes Monte Carlo Analysis.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        The Monte Carlo Analysis runs up to 1,000 simulations using user-defined inputs and assumptions, as well as randomized portfolio returns, to determine the possible probability of success of a financial plan. Portfolio standard deviation, annual average returns, and asset class correlations are based upon historical monthly index returns of each asset class proxy index. With the simulations produced by the Monte Carlo Analysis, there is a range of possible results that depend on the variations of the rate of return. Each simulation randomizes the portfolio's return assumptions based on the portfolio's assumed standard deviation, along a normal or lognormal distribution curve. A successful simulation is when all projected cash needs are satisfied and the ending portfolio of a simulated year is positive. Thus, a success probability score of 90% means that 900 of the 1000 simulations were successful. Additionally, the success or failure of meeting a plan's goals does not factor in by how much or how little the goal was achieved or failed. Failing to meet the goal by a margin of 5 cents is the same as failing to meet the goal by a margin of 5 million dollars.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        Income and capital gains taxes are simulated in the Monte Carlo analysis using the user-defined income and capital gains tax rates, over user-defined time periods. Projected income taxes are assessed on income streams in the plan, and on distributions from tax-deferred accounts.  Projected capital gains taxes are assessed on distributions from taxable accounts. inStream cannot guarantee the inclusion of, or accuracy of the income or capital gains tax inputs and rates used in any plan.                                     </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        Sales loads, expense ratios, management fees and other non-recurring fees associated with certain investment products are not reflected in the analysis.  The performance data does not reflect the deduction of the sales load or fees. If such sales load or fees were reflected, the quoted performance would be reduced.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        The Goals-Based financial plan is a financial planning method whereby financial goals are entered into the Monte Carlo Analysis. Certain assumptions may be included in the plan, and the Monte Carlo Analysis is used to determine the possible probability of successfully achieving the plan's goals.

                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        Based on the unique distribution methodology applied to the IFW Retirement Roadmap the Fixed Index Annuity will be distributed first whenever the investment portfolio experiences a negative return for the year. Once the Fixed Index Annuity is depleted the life insurance cash values will be used to accommodate any income needs for cash flow purposes when the investment portfolio experiences a negative return for the year.
                                    </p>
                                </div>
                                <div style={{ pageBreakBefore: "always" }}>
                                    <span> <b> Analysis  </b> </span>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        It is assumed that the portfolio is rebalanced annually to the allocation model selected for the given time period, so as not to drift excessively from the allocation. Many of the variables used in the calculation are set by the licensed user. The variables used (such as cash flow assumptions, time periods, inflation rates, tax rates, and others) may greatly impact the results of the Analysis.  Results presented in the Analysis have not been examined, endorsed, or validated, in any way, by IFW, and IFW cannot be held liable for any Analysis or any other report that is deemed misleading or misrepresentative, and that is generated by a user through IFW's software application(s).
                                    </p>

                                    <span> <b> Cash Flow Reports </b> </span>

                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        Cash Inflow Report - The cash inflow report illustrates cash inflows such as incomes, that are or will be available to satisfy spending needs (i.e., goals).
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        Cash Outflow Report - The cash outflow report illustrates the goals, or spending needs, that must be satisfied in order for a simulation to be deemed as successful. Outflows include goals and taxes.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        Accounts Summary Report - The accounts summary illustrates the account tax categories and aggregates the value of the accounts, in each category, that is used within the plan. In addition to the balances per tax category, the presentation also indicates the gross distribution amount from each tax category, through the timeline of the financial plan. This table helps to explain when money is being used to satisfy the goals of the plan, and from which tax bucket the money is being used.
                                    </p>
                                    <p style={{ ...justifyStyleText, ...textStyleRoadmaReport }}>
                                        Summary Cash Flow Report - The enhanced cash flow report summarizes the above three reports and also displays the simulated portfolio returns for each year, and the cumulative wealth ending portfolio value.
                                    </p>


                                </div>


                            </div>

                        </Grid>

                    </Grid >
                </Grid >

            </Grid >
        </Dialog >
    );
}

export default RoadmapReport;

